export default __webpack_public_path__ + "static/media/portfolio.c16b000f.png";